import React from 'react';
import { ListItem, ListItemText } from '@mui/material';
import { useDrag } from 'react-dnd';
import { Patient } from '../../interfaces/Patient'

interface PatientItemProps {
    patient: Patient;
    onRemove?: (patient: Patient) => void;
    onClick: () => void;
}

const PatientItem: React.FC<PatientItemProps> = ({ patient, onRemove, onClick }) => {
    const [{ isDragging }, drag] = useDrag(() => ({
        type: 'PATIENT',
        item: patient,
        end: (_, monitor) => {
            const dropResult = monitor.getDropResult();
            // Avoid invoking onRemove when the patient is dropped onto the AvailablePatients unassign zone
            if (dropResult && (dropResult as any).target === 'AVAILABLE_PATIENTS') {
                return; // handled by explicit unassign handler
            }
            if (dropResult && onRemove) {
                onRemove(patient);
            }
        },
        collect: (monitor) => ({
            isDragging: monitor.isDragging(),
        }),
    }));

    const displayName = `${patient.firstname || ''} ${patient.lastname || ''}`.trim();
    const displayId = patient.patient_id || patient.personal_id || 'N/A';

    return (
        <ListItem
            ref={drag}
            style={{ opacity: isDragging ? 0.5 : 1, cursor: 'pointer', padding: '4px 0', margin: '0' }}
            onClick={onClick}
        >
            <ListItemText 
                primary={displayName} 
                secondary={`ID: ${displayId}`}
            />
        </ListItem>
    );
};

export default PatientItem;